import { TranslateLoader } from "@ngx-translate/core";
import { Observable, from } from "rxjs";
import { EnvironmentInjector, runInInjectionContext } from "@angular/core";
import { Database, ref, get } from "@angular/fire/database";

// Translations come from static JSON files in Cloud Storage, published by the
// publishTranslations Cloud Function whenever a language changes. The tiny
// translationsMeta/{lang} node (~200 bytes) says which file is current; the
// file itself is immutable and cached by the browser. This replaces a 77-130
// KB Realtime Database download per session. Any failure (no meta yet, file
// pruned, network or CORS error) falls back to reading translations/{lang}
// from the database, which stays the source of truth.
export class FirebaseTransLoader implements TranslateLoader {
  constructor(
    private mdb: Database,
    private injector: EnvironmentInjector
  ) {}

  public getTranslation(lang: string): Observable<any> {
    return from(this.load(lang));
  }

  private read(path: string): Promise<any> {
    return runInInjectionContext(this.injector, () =>
      get(ref(this.mdb, path))
    ).then((snap) => snap.val());
  }

  private async load(lang: string): Promise<any> {
    try {
      const meta = await this.read(`translationsMeta/${lang}`);
      if (meta?.url) {
        const res = await fetch(meta.url);
        if (res.ok) {
          const json = await res.json();
          if (json && typeof json === "object") return json;
        }
      }
    } catch (e) {
      console.warn(`[translations] static file for ${lang} unavailable, using database`, e);
    }
    return (await this.read(`translations/${lang}`)) ?? {};
  }
}

import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from "@ngx-translate/core";
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return "";
  }
}
